import { onUnmounted, watch, type Ref, type WatchSource } from 'vue';
import { lockPageScroll, unlockPageScroll } from '@/common/utils/scrollLock';

/**
 * 弹层 visible 为 true 时锁定底层滚动；关闭或卸载时释放
 */
export const useScrollLock = (visible: WatchSource<boolean> | Ref<boolean>) => {
  let locked = false;

  const apply = (on: boolean) => {
    if (on && !locked) {
      lockPageScroll();
      locked = true;
    } else if (!on && locked) {
      unlockPageScroll();
      locked = false;
    }
  };

  watch(
    visible,
    (v) => apply(!!v),
    { immediate: true }
  );

  onUnmounted(() => {
    apply(false);
  });
};
